import { Link, type LinkProps } from '@chakra-ui/react';

const localeToSupportURL = {
   'en-us': 'https://help.ifixit.com/article/136-email-support',
   'en-gb': 'https://ifixit-eu-en.helpscoutdocs.com/article/120-how-can-i-contact-you',
   'en-ca': 'https://ca-ifixit-support.helpscoutdocs.com/article/287-contact-us',
   'en-au': 'https://au-ifixit-support.helpscoutdocs.com/article/286-contact-us',
   'en-eu': 'https://ifixit-eu-en.helpscoutdocs.com/article/120-how-can-i-contact-you',
   'fr-fr': 'https://ifixit-eu-fr.helpscoutdocs.com/article/309-nous-contacter',
   'de-de': 'https://ifixit-eu-de.helpscoutdocs.com/article/416-contact-us',
};

const defaultSupportURL = 'https://help.ifixit.com/article/136-email-support';

export type SupportLinkProps = Omit<LinkProps, 'href'> & {
   localeCode: keyof typeof localeToSupportURL;
};

export function SupportLink({ children, localeCode, ...otherProps }: SupportLinkProps) {
   const supportURL = localeToSupportURL[localeCode] ?? defaultSupportURL;
   return (
      <Link href={supportURL} fontWeight="semibold" textDecoration="underline" {...otherProps}>
         {children}
      </Link>
   );
}
